import * as types from 'store/mutation-types'

const state = {
  errorMessage: null
}

const getters = {

}

const actions = {

}

const mutations = {
  [types.APP_ERROR] (state, errorMessage) {
    state.errorMessage = errorMessage
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
